// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__rtZcO","text":"SelectPayment_text__1aumT","title":"SelectPayment_title__1ySGy","btn":"SelectPayment_btn__1Refn"};